import React, {useEffect} from "react";
import {useParams} from 'react-router-dom';

import * as T from 'utils/types';
import { 
    Button,
    Select,
    Skeleton,
    List,
    Grid
} from "antd";
import {useDispatch, useSelector} from "react-redux";
import TotalResult from "components/panel/TotalResult";
import profilePg_gsPubTab_S, { profilePg_gsPubTab_Thunks } from "./gsPubTabSlice";

import Error500 from "components/errors/Error500";
import ToHomeButton from "components/ToHomeButton";
import GsPublicationTitle from "components/gsPublication/GsPublicationTitle";
import GsPublicationDescription from "components/gsPublication/GsPublicationDescription";
import "features/content/search_page/components/TabBlock/PubTab/AltmetricBadge.css";

const {Option}=Select;

// ProfilePage ScopusTab
export default () => {
    const screens = Grid.useBreakpoint();
    const breakpoint = screens.md;

    useEffect(() => {
        // _altmetric_embed_init is offered by Altmetric in embeded.js file
        // this func will let js to find new altmetric-embed div and fetch the data for them
        // eslint-disable-next-line
        eval('if(typeof _altmetric_embed_init!="undefined"){_altmetric_embed_init();}');
    })

    const { randomID } = useParams<{ randomID: string }>();


    const {
        total,
        status,
        hasNext,
        gsPubList,
        yearFilter:{ years, year, total:total_yearFilter, status: status_yearFilter},
        sortType
    } = useSelector((state: T.RootState) => state.profilePg_gsPubTab);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(profilePg_gsPubTab_Thunks.initList({randomID, year, sortType}));
    }, [dispatch, randomID, year, sortType]);


    useEffect(() => {
        dispatch(profilePg_gsPubTab_Thunks.rGsPubYearStat({randomID}));
    }, [dispatch, randomID]);

    if (status==="failed") {
        return (<Error500 extra={<ToHomeButton/>}/>);
    }

    const sortButtons = (
        <>
            <Button
                className="sub-heading-font"
                type="text"
                style={{ fontSize: '13px', color: '#888', marginBottom: 4 }}
                onClick={ () => {
                    if ( sortType !== '-year' && sortType !== 'year') {
                        dispatch(
                            profilePg_gsPubTab_S.actions.setSortType('-year')
                        );
                    } else {
                        dispatch(
                            profilePg_gsPubTab_S.actions.setSortType(
                                sortType==='year'?'-year':'year'
                            )
                        );
                    }
                }}>
                Sort by date {
                  (sortType === 'year' && '\u2191') || (sortType === '-year' && '\u2193')
                }
            </Button>
            <Button
                className="sub-heading-font"
                type="text"
                style={{ fontSize: '13px', color: '#888', marginBottom: 4 }}
                onClick={ () => {
                    if ( sortType !== '-citationCount' && sortType!=='citationCount' ) {
                        dispatch(
                            profilePg_gsPubTab_S.actions.setSortType('-citationCount')
                        );
                    }else{
                        dispatch(
                            profilePg_gsPubTab_S.actions.setSortType(sortType==='citationCount'?'-citationCount':'citationCount')
                        );
                    }
                }}>
                Sort by citation count {
                  (sortType === 'citationCount' && '\u2191') || (sortType === '-citationCount' && '\u2193')
                }
            </Button>
            {/* <Button
                className="sub-heading-font"
                type="text"
                style={{ fontSize: '13px', color: '#888', marginBottom: 4 }}
                onClick={ () => {
                    if (sortType !== '-cited_by_count') {
                        dispatch(
                            profilePg_scopusTab_S.actions.setSortType('-cited_by_count')
                        );
                    }
                }}>
                Sort by citation {sortType === '-cited_by_count' && '\u2193'}
            </Button>
            <Button
                className="sub-heading-font"
                type="text"
                style={{ fontSize: '13px', color: '#888', marginBottom: 4 }}
                onClick={ () => {
                    if (sortType !== '-altmetric_score') {
                        dispatch(
                            profilePg_scopusTab_S.actions.setSortType('-altmetric_score')
                        );
                    }
                }}>
                Sort by Altmetric score {sortType === '-altmetric_score' && '\u2193'}
            </Button> */}
        </>
    );

    return <>
        {total>=0&&<TotalResult searchResult={total}/>}

        {total_yearFilter>=0&&<Select
            className="sub-heading-font"
            value={year}
            style={{ width:200, marginRight: 8, marginBottom: 4 }}
            //selectEntries={publicationYearOptions}
            onChange={ value => {
                dispatch(
                    profilePg_gsPubTab_S.actions.setYear(value)
                );
            }}
            loading={status_yearFilter!=="succeeded"}
            disabled={status_yearFilter!=="succeeded"}
            filterOption={(input, option) => (option !== undefined) && 
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
        >
            {[
                <Option className="sub-heading-font" value={-1} key={-1}>
                    {`All years (${total_yearFilter})`}
                </Option>,
                ...(years.map( x => 
                <Option className="sub-heading-font" value={x.year} key={x.year}>
                    {`${x.year} (${x.cnt})`}
                </Option>))
            ]}
        </Select>}

        {breakpoint ? <>{sortButtons}</> : (
            <div style={{ display: 'flex', overflowX: 'scroll' }}>
                {sortButtons}
            </div>
        )}

         <List
            loading={status==="idle"}
            itemLayout="horizontal"
            loadMore={
                hasNext ? <div
                    style={{
                        textAlign: 'center',
                        marginTop: 12,
                        height: 32,
                        lineHeight: '32px',
                    }}
                >
                    <Button
                        className="sub-heading-font"
                        onClick={() => dispatch(profilePg_gsPubTab_Thunks.loadMore({randomID}))}
                    >
                        More
                    </Button>
                </div> : null
            }
            dataSource={gsPubList}
            renderItem={ item => {
                const pub = item.item as T.GsPublication;
                return <List.Item>
                    <Skeleton avatar title={false} loading={item.loading} active>
                        <List.Item.Meta

                            avatar={<div
                                    className='altmetric-embed'
                                    data-badge-type='donut'
                                    data-badge-popover="right"
                                    data-link-target='_blank'
                                    data-doi={pub?.doi||"0"}
                                ></div>}

                            title={ <GsPublicationTitle gsPub={pub}/> }

                            description={ <GsPublicationDescription gsPub={pub}/> }

                        />
                    </Skeleton>
                </List.Item>;
            } }
        />

    </>;
}
